"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapVerifyOtpLoginToChallenge = void 0;
const challengeUtils_1 = require("../../../../../features/authoriser/utils/challengeUtils");
const mapVerifyOtpLoginToChallenge = (verifyOtpLoginResponse) => (0, challengeUtils_1.mapToChallenge)(verifyOtpLoginResponse);
exports.mapVerifyOtpLoginToChallenge = mapVerifyOtpLoginToChallenge;
//# sourceMappingURL=mapper.js.map